// extracted by mini-css-extract-plugin
export default {"root":"B_xVICz4QU","root_clickable":"YTUJauQSUU","icon":"c8Ww8fD_Ol","name":"jGVCM64Qui","bookmark":"LZTcLq_PWy","infected":"lu_hRWhWiJ"};